export default __webpack_public_path__ + "static/media/Laxmi-Narayan-Temple.a0464da3.jpg";